import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import type { IOpenSourceDetails } from '../../types/stateTypes';
import { OpenSourceHook } from './OpenSourceHook';

const OpenSource = () => {
  const { fetchData, openSourceList } = OpenSourceHook();

  useEffect(() => {
    fetchData();
  }, []);

  const { t } = useTranslation();
  return (
    <>
      {openSourceList && openSourceList.length > 0 && (
        <div className="open-source">
          <div className="wrapper">
            <main>
              <h1>{t('openSource.title')}</h1>
              <div className="detail-wrapper">
                {openSourceList.map((data: IOpenSourceDetails, index: number) => {
                  return (
                    <div className="detail-block" key={index}>
                      <p>
                        {data.name} <br /> <br />
                        {data.description}
                      </p>
                      <div className="links-wrapper">
                        <a href={data.url} target="_blank" rel="noopener noreferrer" className="link">
                          {data.license}
                        </a>
                      </div>
                    </div>
                  );
                })}
              </div>
            </main>
          </div>
        </div>
      )}
    </>
  );
};

export default OpenSource;
